import React from 'react';

import {DeviceViewModel} from "../../../models/device.view-model";
import {GameCardPlaceholderComponent} from "../../game-card/components/game-card.placeholder";
import {ScoresHeaderPlaceholder} from "./scores.header.placeholder";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class ScoresSectionPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const ScoresSectionPlaceholder = (props: ScoresSectionPlaceholderProps) => {
  const games: Array<Object> = [];
  const numOfGames: Number = 3;

  for (let i = 0; i < numOfGames; i++) {
    games.push({
      key: i
    });
  }

  return (
    <div className={'scores-section-placeholder-container'}>
      <div className={'scores-section-placeholder-section'}>
        <ScoresHeaderPlaceholder {...props}/>
        {
          games.map((placeholderProps) => <GameCardPlaceholderComponent key={placeholderProps.key} {...props}/>)
        }
      </div>
    </div>
  )
}
